import React from 'react';
import classnames from 'classnames';

import { is768Query } from '~/core/scripts/mediaquery-helper';
import Icon from '~/core/scripts/components/Icon';
import { sortByKey, numberFormat } from '~/core/scripts/utils';
import { getWeekRangeDates } from '../../utils';

import './tooltip.styl';

const TOOLTIP_WIDTH = 250;

const Tooltip = props => {
  const { data, pos, isVisible, onClose } = props;
  const style = is768Query() ? { left: `${pos.x + 40}px`, top: `${pos.y - 75}px` } : {};
  const isInverted = pos.x + 120 + TOOLTIP_WIDTH >= window.innerWidth;
  const tooltipClass = classnames('tooltip-wrapper', { 'is-active': isVisible, invert: isInverted });

  if (!data || !isVisible) {
    return null;
  }

  const absValue = data.abs;
  const relValue = data.rel;
  const weekRange = getWeekRangeDates(data.date);

  return (
    <div className={tooltipClass} style={{ ...style, borderColor: data.color }}>
      <div className="tooltip">
        <button className="btn close" onClick={onClose}>
          <Icon type="close" />
        </button>
        <div className="tooltip-header">
          <div className="tooltip-title">Kalenderwoche {data.week}</div>
          <div className="tooltip-subtitle">{weekRange[0]} bis {weekRange[1]}</div>
        </div>
        {typeof absValue === 'undefined' ?
          <div className="tooltip-body">
            Keine Daten vorhanden
          </div> :
          <div className="tooltip-body">
            <div className="tooltip-value">{numberFormat(absValue)}</div>
            <div className="tooltip-label">von Laboren gemeldete Fälle</div>
          </div>
        }
      </div>
    </div>
  );
};

export default Tooltip;
